__turbopack_context__.v({
  "header": "vcZAwq_header",
  "headerWrapper": "vcZAwq_headerWrapper",
  "homeLink": "vcZAwq_homeLink",
  "title": "vcZAwq_title",
});
